import React, { useState, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import "./BlogLayout.css";

const BlogLayout = ({ title, children, customClass = "" }) => {
  const [showHeader, setShowHeader] = useState(true);
  const [showTitleBar, setShowTitleBar] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Calculate scroll progress
      const progress = (currentScrollY / (documentHeight - windowHeight)) * 100;
      setScrollProgress(progress);

      if (currentScrollY > lastScrollY) {
        // Scrolling down → Show title bar, hide header
        setShowHeader(false);
        setShowTitleBar(true);
      } else {
        // Scrolling up → Show header, hide title bar
        setShowHeader(true);
        setShowTitleBar(false);
      }

      setLastScrollY(currentScrollY);

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setShowHeader(true);
        setShowTitleBar(false);
      }, 200);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, [lastScrollY]);

  return (
    <div className="blogpage-container">
      {/* Header - Only appears when scrolling up */}
      <header className={`site-header ${showHeader ? "visible" : "hidden"}`}>
        <Header />
      </header>

      {/* Title Bar - Appears when scrolling down */}
      {showTitleBar && (
        <div className={`title-bar ${customClass || ""}`}>
          <div className="title-bar-inner">
            <h2 className="title-bar-heading">{title}</h2>
            <div className="progress-bar-container">
              <div
                className="progress-bar"
                style={{ width: `${scrollProgress}%` }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main className="main-content">
        <div className="article-container">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export default BlogLayout;
